"use strict";

// Handles the newsletter success popup -- the form submits naturally and
// Shopify's own form.posted_successfully? check in the Liquid template sets
// window.__newsletterSuccess when the subscription is confirmed
Shopify.theme.jsNewsletter = {

  init: function init() {
    var $ajaxForm = $('.newsletter-form__wrapper .contact-form');

    $ajaxForm.each(function () {
      var $form = $(this);
      var $wrapper = $form.closest('.newsletter-form__wrapper');

      // Move the overlay to the body so position: fixed works correctly
      // against the viewport, regardless of any CSS transforms on parent elements
      var $overlay = $wrapper.find('.newsletter-success-overlay').appendTo('body');
      var $closeButton = $overlay.find('.newsletter-success-close');

      // Close the popup when the user clicks the dark background behind it
      $overlay.on('click', function (clickEvent) {
        if ($(clickEvent.target).is($overlay)) {
          $overlay.removeClass('is-visible');
        }
      });

      // Close the popup when the user clicks the X button
      $closeButton.on('click', function () {
        $overlay.removeClass('is-visible');
      });
    });
  },

  unload: function unload() {}

};

// Run on page load -- does not rely on the theme section framework
$(document).ready(function () {
  Shopify.theme.jsNewsletter.init();

  // Show the success popup if Shopify confirmed the subscription.
  // window.__newsletterSuccess is set by an inline script in the newsletter
  // snippet when form.posted_successfully? is true.
  // The sessionStorage flag covers the case where the user had to complete
  // a captcha challenge before the subscription was processed.
  var isPostedSuccessfully = window.__newsletterSuccess === true;
  var wasCaptchaPending = sessionStorage.getItem('newsletter_captcha_pending') === '1';

  if (isPostedSuccessfully || wasCaptchaPending) {
    sessionStorage.removeItem('newsletter_captcha_pending');

    var $newsletterOverlay = $('.newsletter-success-overlay').first();

    // Use the Shopify translation if available, otherwise use a plain fallback
    var successMessage = 'Thank you for subscribing!';
    if (Shopify.translation && Shopify.translation.newsletter_form_success) {
      successMessage = Shopify.translation.newsletter_form_success;
    }

    if ($newsletterOverlay.length) {
      $newsletterOverlay.find('.newsletter-success-message').html(successMessage);
      $newsletterOverlay.addClass('is-visible');
    }
  }
});
